import styled from 'styled-components';

export const StyledUnsubscribeAlertEmail = styled.div``;
